var _path, _path2, _g, _path3, _path4, _path5, _g2, _g3, _g4, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0596 3.76758C42.0815 1.44576 47.0367 1.44575 51.0586 3.76758L77.5244 19.0469C81.5466 21.3691 84.0244 25.6613 84.0244 30.3057V60.8643C84.0243 65.5084 81.5463 69.7999 77.5244 72.1221L51.0586 87.4014C47.0365 89.7233 42.0816 89.7234 38.0596 87.4014L11.5938 72.1221C7.57185 69.7999 5.0939 65.5084 5.09375 60.8643V30.3057C5.09375 25.6612 7.5716 21.3691 11.5938 19.0469L38.0596 3.76758Z",
    fill: "#F3F0FF",
    stroke: "#CFBFFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2475_17902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 78,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5591 2.90192C43.4155 1.83016 45.7027 1.83015 47.559 2.90192L80.024 21.6453C81.8804 22.7171 83.024 24.6978 83.024 26.8414V64.328C83.024 66.4716 81.8804 68.4524 80.024 69.5241L47.559 88.2675C45.7027 89.3393 43.4155 89.3393 41.5591 88.2675L9.09415 69.5242C7.23772 68.4524 6.0941 66.4716 6.0941 64.328V26.8414C6.0941 24.6978 7.23771 22.7171 9.09414 21.6453L41.5591 2.90192Z",
    fill: "#EDF2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2475_17902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2226 53.7924C16.2957 48.1421 19.1748 42.5507 24.3126 40.0232L41.1333 31.7482C42.1889 31.229 43.31 30.8554 44.466 30.6377L71.6253 25.523C78.4765 24.2328 85.1258 28.5767 86.6968 35.369L93.1227 63.1515C94.5221 69.2021 91.4465 75.3976 85.7809 77.9408L46.9186 95.3858C41.597 97.7747 35.3357 96.3263 31.6037 91.8432L23.7313 82.3865C22.2487 80.6055 21.2691 78.4605 20.8939 76.1736L17.2226 53.7924Z",
    fill: "#E5DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4207 81.6363C23.726 83.22 25.1792 84.3412 26.8394 84.4006C26.8488 84.3996 26.8582 84.3986 26.8678 84.3977C26.9201 84.393 26.9771 84.3899 27.038 84.3897L27.5518 84.3349L27.5625 84.3338L27.5732 84.3328L94.0343 78.0826L82.5673 18.6027L13.8236 31.8557L23.4207 81.6363ZM97.325 78.1121C97.5968 79.5222 96.4998 80.8744 94.9672 81.0183L27.8198 87.333L27.0497 87.4151L27.0237 87.4201L27.0036 87.4199L26.8997 87.4311L26.8476 87.419C23.6689 87.3986 20.8423 85.3012 20.2535 82.2469L10.5451 31.8895C10.2921 30.5771 11.2281 29.2927 12.6356 29.0213L82.6147 15.5302C84.0184 15.2596 85.3696 16.0994 85.6233 17.4153L97.325 78.1121Z",
    fill: "#CFBFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2475_17902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 78.4229L24.1424 94.0221L101.768 81.8354L31.7353 74.293C29.7241 82.0505 24.0738 80.2785 21.5 78.4229Z",
    fill: "#B197FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.3826 43.7966L86.9453 30.193L84.6689 18.3852L14.1062 31.9889L16.3826 43.7966ZM90.3053 30.1298C90.5368 31.3306 89.568 32.5268 88.1426 32.8016L16.2411 46.6634C14.8152 46.9383 13.4715 46.1878 13.24 44.9871L10.7463 32.0521C10.5148 30.8513 11.4831 29.6551 12.9091 29.3802L84.8105 15.5184C86.236 15.2436 87.5801 15.9939 87.8116 17.1948L90.3053 30.1298Z",
    fill: "#CFBFFF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4616 4.64702L16.8231 1.81926L19.8333 4.66839L12.8736 7.68621L10.4616 4.64702Z",
    fill: "#7950F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4515 3.25814L67.0263 3.07731L66.0407 1.68788L61.0928 1.90934L62.4515 3.25814Z",
    fill: "#FFEC99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6127 5.66388L77.4 10.7567L78.2955 8.13213L75.5031 3.52744L74.6127 5.66388Z",
    fill: "#FFC9C9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2475_17902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.7559,
    y: 44.6766,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 23.7559 44.6766)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6546 42.3334C34.9276 42.5433 35.0077 42.9542 34.8336 43.2512L30.3757 50.8566C30.2016 51.1536 29.8392 51.2243 29.5663 51.0144L26.072 48.3277C25.7991 48.1178 25.7189 47.7069 25.893 47.4099C26.0671 47.1129 26.4295 47.0423 26.7024 47.2521L29.7026 49.5589L33.8453 42.4913C34.0193 42.1943 34.3817 42.1236 34.6546 42.3334Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5554 42.3206C33.8311 41.8504 34.4247 41.7348 34.8569 42.0669C35.2631 42.3794 35.3788 42.9763 35.1196 43.4185L30.662 51.0241C30.3863 51.4944 29.7937 51.6099 29.3615 51.2777L25.8668 48.5912C25.4607 48.2787 25.3441 47.6819 25.6032 47.2397C25.8789 46.7693 26.4724 46.6537 26.9047 46.9861L29.6039 49.0609L33.5554 42.3206ZM34.4494 42.5968C34.3359 42.5096 34.2042 42.5359 34.1318 42.6594L29.9888 49.7266C29.9403 49.8091 29.8586 49.8671 29.7646 49.8854C29.6707 49.9036 29.5732 49.8808 29.4974 49.8225L26.4971 47.515C26.3836 47.428 26.2518 47.4542 26.1795 47.5776C26.0907 47.7294 26.135 47.954 26.2743 48.0613L29.7681 50.7489C29.8816 50.836 30.0133 50.8097 30.0857 50.6863L34.5433 43.0807C34.6322 42.9289 34.5888 42.7041 34.4494 42.5968Z",
    fill: "#F3F0FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2475_17902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.1944,
    y: 60.2216,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 26.1944 60.2216)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0921 57.8774C37.3651 58.0872 37.4452 58.4981 37.2711 58.7951L32.8132 66.4006C32.6391 66.6976 32.2767 66.7682 32.0038 66.5584L28.5095 63.8716C28.2366 63.6618 28.1564 63.2509 28.3305 62.9539C28.5046 62.6569 28.867 62.5862 29.1399 62.7961L32.1401 65.1029L36.2828 58.0352C36.4568 57.7382 36.8192 57.6675 37.0921 57.8774Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9929 57.8665C36.2686 57.3963 36.8622 57.2807 37.2944 57.6128C37.7006 57.9252 37.8171 58.5221 37.5581 58.9642L33.0995 66.57C32.8237 67.0401 32.2311 67.1558 31.799 66.8236L28.3043 64.1371C27.8982 63.8246 27.7825 63.2276 28.0416 62.7855C28.3174 62.3152 28.91 62.1996 29.3422 62.532L32.0414 64.6068L35.9929 57.8665ZM36.8869 58.1427C36.7734 58.0556 36.6416 58.0808 36.5692 58.2043L32.4272 65.2723C32.3788 65.3548 32.2969 65.4128 32.2031 65.4312C32.1091 65.4495 32.0108 65.4268 31.9349 65.3684L28.9346 63.0609C28.8211 62.974 28.6903 62.9999 28.6179 63.1233C28.529 63.2751 28.5724 63.4999 28.7118 63.6072L32.2065 66.2937C32.3199 66.3808 32.4508 66.3554 32.5232 66.2322L36.9818 58.6264C37.0705 58.4746 37.0263 58.2499 36.8869 58.1427Z",
    fill: "#F3F0FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2475_17902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5733,
    y: 28.163,
    width: 8.86825,
    height: 8.86825,
    rx: 4,
    transform: "rotate(-8.03187 21.5733 28.163)",
    fill: "#B197FC",
    stroke: "#B197FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.472 25.8198C32.745 26.0296 32.8251 26.4405 32.651 26.7375L28.1931 34.3429C28.019 34.64 27.6566 34.7106 27.3837 34.5008L23.8894 31.814C23.6164 31.6042 23.5363 31.1933 23.7104 30.8963C23.8845 30.5993 24.2469 30.5286 24.5198 30.7384L27.5199 33.0452L31.6626 25.9776C31.8367 25.6806 32.1991 25.6099 32.472 25.8198Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3737 25.8099C31.6494 25.3398 32.2422 25.2245 32.6743 25.5563C33.0807 25.8688 33.1972 26.4655 32.938 26.9077L28.4804 34.5134C28.2047 34.9837 27.612 35.0991 27.1798 34.7669L23.6852 32.0804C23.279 31.768 23.1624 31.1712 23.4215 30.729C23.6973 30.2586 24.2908 30.143 24.7231 30.4753L27.4224 32.5511L31.3737 25.8099ZM32.2678 26.0861C32.1542 25.9988 32.0226 26.0251 31.9502 26.1487L27.8071 33.2158C27.7586 33.2984 27.677 33.3564 27.583 33.3747C27.489 33.3929 27.3916 33.3701 27.3157 33.3118L24.3154 31.0043C24.2019 30.9172 24.0702 30.9434 23.9978 31.0668C23.909 31.2186 23.9533 31.4433 24.0927 31.5505L27.5865 34.2381C27.7 34.3252 27.8317 34.2989 27.9041 34.1756L32.3617 26.5699C32.4506 26.4181 32.4072 26.1934 32.2678 26.0861Z",
    fill: "#F3F0FF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3086 29.9687C45.3086 28.1889 46.7514 26.7461 48.5312 26.7461H61.4219C63.2017 26.7461 64.6445 28.1889 64.6445 29.9687C64.6445 31.7486 63.2017 33.1914 61.4219 33.1914H51.7539V39.6367H58.1992C59.9086 39.6367 61.548 40.3158 62.7567 41.5245C63.9655 42.7332 64.6445 44.3726 64.6445 46.082V52.5273C64.6445 54.2367 63.9655 55.8761 62.7567 57.0848C61.548 58.2936 59.9086 58.9726 58.1992 58.9726H51.7539C50.0445 58.9726 48.4051 58.2936 47.1964 57.0848C45.9877 55.8761 45.3086 54.2367 45.3086 52.5273C45.3086 50.7475 46.7514 49.3047 48.5312 49.3047C50.3111 49.3047 51.7539 50.7475 51.7539 52.5273H58.1992V46.082H48.5312C46.7514 46.082 45.3086 44.6392 45.3086 42.8594V29.9687Z",
    fill: "#7950F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1685 18.433L54.5361 14.4534L56.5258 11.2695L63.689 15.6469L61.1685 18.433Z",
    fill: "#FFC9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.596 42.4071L81.3999 38.1098L83.2199 35.0291L88.8272 39.7495L86.596 42.4071Z",
    fill: "#99E9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7791 22.4557L18.7858 19.6901L20.1494 17.7501L24.5539 18.3321L22.7791 22.4557Z",
    fill: "#99E9F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.84494 36.8891L5.40418 32.3754L6.60661 34.775L1.63593 39.6309L0.84494 36.8891Z",
    fill: "#99E9F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3609 75.6141L15.4863 72.404L16.2661 74.0656L12.8595 77.5199L12.3609 75.6141Z",
    fill: "#7950F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6393 20.9078L69.5399 18.0131L70.9399 19.927L66.6806 23.0344L65.6393 20.9078Z",
    fill: "#7950F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6645 3.42241L31.9711 5.90744L33.0641 9.74312L27.2842 6.97622L26.6645 3.42241Z",
    fill: "#99E9F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 20.0366L27.6377 17.4132L26.3261 15.3145L21.6041 18.2L23.2656 20.0366Z",
    fill: "#FFEC99"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3588 3.10677L66.9335 2.92594L65.9479 1.53651L61.0001 1.75797L62.3588 3.10677Z",
    fill: "#FFEC99"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6421 13.8176L66.8855 14.9175L67.7578 13.3099L64.2215 12.1451L63.6421 13.8176Z",
    fill: "#FFEC99"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3651 75.1877L47.5154 76.791L48.9744 74.2301L43.3576 72.5361L42.3651 75.1877Z",
    fill: "#FFEC99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5815 11.5572L16.2139 7.57759L15.0687 5.83398L8.48869 9.80112L9.5815 11.5572Z",
    fill: "#FFC9C9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5199 5.51251L77.3073 10.6053L78.2028 7.98077L75.4103 3.37608L74.5199 5.51251Z",
    fill: "#FFC9C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7847 80.9183L80.7343 81.542L79.6709 79.4267L75.0221 79.0722L75.7847 80.9183Z",
    fill: "#FFC9C9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0659 36.1259L20.6982 33.5945L18.7085 31.5693L11.5454 34.3538L14.0659 36.1259Z",
    fill: "#FFC9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2475_17902",
    x: 7.9,
    y: 68.693,
    width: 93.8686,
    height: 30.9295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.677775 0 0 0 0 0.599488 0 0 0 0 0.903602 0 0 0 0.61 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2475_17902",
    x: 16.2754,
    y: 37.877,
    width: 19.9824,
    height: 20.0615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2475_17902",
    x: 18.7139,
    y: 53.4229,
    width: 19.9824,
    height: 20.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2475_17902",
    x: 14.0928,
    y: 21.3662,
    width: 19.9834,
    height: 20.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700697 0 0 0 0 0.642201 0 0 0 0 0.865216 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2475_17902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2475_17902",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.f1686fe1dd633d059c479f7909de9ba2.svg";
export { ForwardRef as ReactComponent };